import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { jsx } from "react/jsx-runtime";
import "@khmyznikov/pwa-install";

//#region src/components/ui/common/PwaInstall.tsx
const PwaInstall = forwardRef((props, ref) => {
	const pwaInstallRef = useRef(null);
	useImperativeHandle(ref, () => ({
		install: () => {
			pwaInstallRef.current?.install();
		},
		showDialog: (forced) => {
			pwaInstallRef.current?.showDialog(forced);
		},
		hideDialog: () => {
			pwaInstallRef.current?.hideDialog();
		},
		getInstalledRelatedApps: async () => {
			return await pwaInstallRef.current?.getInstalledRelatedApps();
		},
		userChoiceResult: pwaInstallRef.current?.userChoiceResult || "",
		isDialogHidden: pwaInstallRef.current?.isDialogHidden || true,
		isInstallAvailable: pwaInstallRef.current?.isInstallAvailable || false,
		isAppleMobilePlatform: pwaInstallRef.current?.isAppleMobilePlatform || false,
		isAppleDesktopPlatform: pwaInstallRef.current?.isAppleDesktopPlatform || false,
		isUnderStandaloneMode: pwaInstallRef.current?.isUnderStandaloneMode || false,
		isRelatedAppsInstalled: pwaInstallRef.current?.isRelatedAppsInstalled || false
	}));
	useEffect(() => {
		const pwaInstallElement = pwaInstallRef.current;
		if (!pwaInstallElement) return;
		const { onInstallSuccess, onInstallFail, onInstallAvailable, onUserChoiceResult, onInstallHowTo, onInstallGallery } = props;
		const eventCallbackMap = {
			"pwa-install-success-event": onInstallSuccess,
			"pwa-install-fail-event": onInstallFail,
			"pwa-install-available-event": onInstallAvailable,
			"pwa-user-choice-result-event": onUserChoiceResult,
			"pwa-install-how-to-event": onInstallHowTo,
			"pwa-install-gallery-event": onInstallGallery
		};
		const listeners = {};
		Object.entries(eventCallbackMap).forEach(([eventName, callback]) => {
			if (callback) {
				const listener = (event) => {
					callback(event);
				};
				listeners[eventName] = listener;
				pwaInstallElement.addEventListener(eventName, listener);
			}
		});
		return () => {
			Object.entries(listeners).forEach(([eventName, listener]) => {
				pwaInstallElement.removeEventListener(eventName, listener);
			});
		};
	}, [props]);
	return /* @__PURE__ */ jsx("pwa-install", {
		ref: (el) => {
			pwaInstallRef.current = el;
			if (el && window.promptEvent) el.externalPromptEvent = window.promptEvent;
		},
		"manual-apple": props.manualApple,
		"manual-chrome": props.manualChrome,
		"disable-chrome": props.disableChrome,
		"disable-close": props.disableClose,
		"use-local-storage": props.useLocalStorage,
		"install-description": props.installDescription,
		"disable-install-description": props.disableInstallDescription,
		"disable-screenshots": props.disableScreenshots,
		"disable-screenshots-apple": props.disableScreenshotsApple,
		"disable-screenshots-chrome": props.disableScreenshotsChrome,
		"disable-android-fallback": props.disableAndroidFallback,
		"manifest-url": props.manifestUrl,
		name: props.name,
		description: props.description,
		icon: props.icon
	});
});
PwaInstall.displayName = "PwaInstall";

//#endregion
export { PwaInstall as default };
//# sourceMappingURL=PwaInstall.mjs.map